// extracted by mini-css-extract-plugin
export default {"Error404":"Error404_Error404__apteo"};